<template>
  <div v-bind:class="{loading: isLoading}" id="sell-browse" class="columns">
    <div class="column is-3">
      <h2 class="subtitle">Browse</h2>
      <aside class="menu">
        <ul class="menu-list">
          <li v-for="s in sets">
            <router-link v-bind:class="{'is-active': $route.params.id === s.uuid}" :to="{name: 'SellViewCategory', params: { id: s.uuid}}">{{ s.name }}</router-link>
          </li>
        </ul>
      </aside>
    </div>
    <div class="column">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Raven from 'raven-js';

export default {
  name: 'sell-browse',
  data() {
    return {
      isLoading: false,
      sets: [],
    };
  },
  mounted() {
    this.isLoading = true;
    this.axios.get('https://inventory.powernine.com/shopify/sets').then((response) => {
      this.sets = response.data;
      this.isLoading = false;
    }).catch((err) => {
      this.isLoading = false;
      Raven.captureException(err);
      throw err;
    });
  },
};
</script>



// WEBPACK FOOTER //
// SellBrowse.vue?7dd64178